import { ExpandedList } from "./ExpandedList"
import { SingleBanner } from "./SingleBanner"
import { StackedBanners } from "./StackedBanners"

import type { DisplayMode, NotificationItem } from "./types"

export function NotificationUI({
	notifications,
	displayMode,
	dismissError,
	clearAll,
	handleBannerClick,
	handleStackedClick,
}: {
	notifications: NotificationItem[]
	displayMode: DisplayMode
	dismissError: (id: string) => void
	clearAll: () => void
	handleBannerClick: () => void
	handleStackedClick: () => void
}) {
	switch (displayMode) {
		case "single":
			return (
				<SingleBanner
					notification={notifications[notifications.length - 1]}
					onDismiss={dismissError}
					onBannerClick={handleBannerClick}
				/>
			)
		case "stacked":
			return (
				<StackedBanners
					notifications={notifications}
					onDismiss={dismissError}
					onClearAll={clearAll}
					onStackedClick={handleStackedClick}
				/>
			)
		case "expanded":
			return (
				<ExpandedList
					notifications={notifications}
					onDismiss={dismissError}
					onClearAll={clearAll}
				/>
			)
		default:
			return null
	}
}
